import React from 'react';
import PropTypes from 'prop-types';
import { CustomComponent } from './custom-component';

export const withCustomRendering = (Component) => {
  const CustomRenderingWrapper = (props) => {
    const { Renderer } = props;

    return (
      <>
        {Renderer ? <CustomComponent {...props} /> : <Component {...props} />}
      </>
    );
  };

  CustomRenderingWrapper.propTypes = {
    Renderer: PropTypes.elementType,
  };

  CustomRenderingWrapper.defaultProps = {
    Renderer: null,
  };

  return CustomRenderingWrapper;
};
